import { useCallback, useState } from 'react';
import { SaveButton } from './SaveButton';

export const UncontrolledSaveButton = ({ onClick, ...restProps }) => {
    const [saving, setSaving] = useState(false);

    const handleClick = useCallback(async () => {
        setSaving(true);

        await onClick();

        setSaving(false);
    }, [onClick]);

    return (
        <SaveButton
            saving={saving}
            onClick={handleClick}
            {...restProps}
        />
    );
};